import { render, staticRenderFns } from "./TPS.vue?vue&type=template&id=c2d8dcc0&scoped=true"
import script from "./TPS.vue?vue&type=script&lang=js"
export * from "./TPS.vue?vue&type=script&lang=js"
import style0 from "./TPS.vue?vue&type=style&index=0&id=c2d8dcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8dcc0",
  null
  
)

export default component.exports